var RosterUploadProgressMeter = require("components/org/roster_upload/RosterUploadProgressMeter");
var RosterUploadButtons = require("components/org/roster_upload/RosterUploadButtons");
var Glyphicon = require("components/utility/icons/Glyphicon");
var DropDownOptions = require("components/utility/DropDownOptions");
var StudentRoster = require("lib/data/StudentRoster");
var GradeLevel = require("lib/academic/GradeLevel");
var MappingControl = require("components/org/roster_upload/MappingControl");

class RosterUploadGrades extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			editMode: this.forceEdits(props)
		};
	}

	forceEdits(props) {
		var props = props || this.props;
		return props.roster.invalidGradeLevels().length > 0;
	}

	toggleEditMode(e) {
		$wr.nope(e)
		this.setState({ editMode: !this.state.editMode }, function() {
			$(window).trigger("resize");
		});
	}

	confirmChanges() {
		var mapValues = {};
		var $selects = $(this.refs.table).find("[data-grade-level]");

		_.each($selects, function(select) {
			var origGradeLevel = $(select).data("grade-level");
			var newVal = $(select).val();
			mapValues[origGradeLevel] = newVal;
		});

		var mappedRosterData = this.props.roster.
			mapColumnValues(StudentRoster.Columns.GRADE_LEVEL, mapValues);

		this.props.updateRosterData(mappedRosterData, function() {
			this.setState({ editMode: this.forceEdits() });
		}.bind(this));
	}

	archivedStudents() {
		return this.props.archivedStudents || [];
	}

	tryNextStage() {
		if (this.archivedStudents().length > 0) {
			if (confirm("Have you reviewed the existing student accounts?")) {
				var mergedRosterData = this.props.roster.
					mergeStudentIDs(_.invert(this.refs.mapper.getMapping()));

				this.props.updateRosterData(mergedRosterData, function() {
					this.props.nextStage();
				}.bind(this));				
			}
		} else {
			this.props.nextStage();
		}
	}

	renderRosterStatus() {
		if (this.props.roster.invalidGradeLevels().length > 0) {
			return (
				<p className="redBold">
					Your roster contained some unknown grade levels
					(the ones marked with <Glyphicon icon="question-sign" className="unrecognized" />).
					Please edit these, so the student accounts will be created correctly.
				</p>
			)
		}
	}

	renderTableHeader() {
		return (
			<tr>
				<th className="editCol" colSpan={ 2 }>
					Grade Level
				</th>
				<th>Number of Students</th>
			</tr>
		);
	}

	renderTableRows() {
		var gradeLevels = this.props.roster.getColumn(StudentRoster.Columns.GRADE_LEVEL);
		gradeLevels = _.compact(gradeLevels).sort();
		return _.map(_.uniq(gradeLevels), function(gradeLevel) {
			var valid = GradeLevel.isValid(gradeLevel);
			var glCount = _.select(gradeLevels, function(gl) {
				return gl == gradeLevel;
			}).length;

			var sampleCell = (<td className="csvSampleText">{ glCount }</td>);

			if (this.state.editMode) {
				var selectClassName = "form-control" + (valid ? "" : " unrecognized");
				return (
					<tr key={ gradeLevel }>
						<td>{ gradeLevel }<span className="spacer2" /><Glyphicon icon="arrow-right" /></td>
						<td>
							<select className={ selectClassName } defaultValue={ gradeLevel }
								data-grade-level={ gradeLevel } >
								{ DropDownOptions.Select.GradeLevels() }
							</select>
						</td>
						{ sampleCell }
					</tr>
				)

			} else {
				if (valid) {
					var gradeContents = GradeLevel.getName(gradeLevel);
				} else {
					var gradeContents = (
						<span>
							<Glyphicon icon="question-sign" className="unrecognized" /> {gradeLevel}
						</span>
					);
				}

				return (
					<tr key={ gradeLevel }>
						<td colSpan={2}>{ gradeContents }</td>
						{ sampleCell }
					</tr>
				);
			}
		}.bind(this));
	}

	mapItemRenderer(item) {
		return (
			<div>
				{ item.first_name } { item.last_name }<br />
				<em>{ GradeLevel.getName(item.grade_level) }</em>
			</div>
		);
	}
	mapItemSorter(list) {
		return _.sortBy(list, function(item) {
			return [$wr.padleft(item.grade_level, 2), item.last_name, item.first_name].join("_");
		});
	}
	mapItemMatcher(oldStudent, newStudent) {
		var points = 0;
		var maxPoints = 6;

		if ((parseInt(oldStudent.grade_level) + 1) == parseInt(newStudent.grade_level)) {
			points += 2;
		}

		var oldFirst = (oldStudent.first_name || "").toLowerCase();
		var newFirst = (newStudent.first_name || "").toLowerCase();
		var oldLast = (oldStudent.last_name || "").toLowerCase();
		var newLast = (newStudent.last_name || "").toLowerCase();

		if (oldFirst == newFirst) {
			points += 2;
		} else if (oldFirst.includes(newFirst)) {
			points += 1;
		} else if (newFirst.includes(oldFirst)) {
			points += 1;
		}

		if ((oldLast.length == 1) || (newLast.length == 1)) {
			if (oldLast.charAt(0) == newLast.charAt(0)) {
				points += 2;
			}
		} else {
			if (oldLast == newLast) {
				points += 2;
			} else if (oldLast.includes(newLast)) {
				points += 1;
			} else if (newLast.includes(oldLast)) {
				points += 1;
			}
		}

		return points / maxPoints;
	}

	renderArchivedMapper() {
		return (
			<div className="archivedMapper">
				<p>
					We've detected archived student accounts which should potentially 
					be included in this upload. Please review:
				</p>

				<MappingControl ref="mapper" keyAttr="id" rightKeyAttr="rosterIndex"
					left={ this.archivedStudents() } right={ this.props.roster.getStudents() } 
					leftLabel="Last year" rightLabel="This year"
					itemRenderer={ this.mapItemRenderer }
					initialMatcher={ this.mapItemMatcher } itemSorter={ this.mapItemSorter } />

			</div>
		);
	}

	render() {
		var gradeCount = _.uniq(this.props.roster.getColumn(StudentRoster.Columns.GRADE_LEVEL)).length;

		if (this.archivedStudents().length > 0) {
			var archivedMapper = this.renderArchivedMapper();
		}

		return (
			<div className="uploadManager">
				<RosterUploadProgressMeter index={ 2 } />

				{ this.renderRosterStatus() }

				<p>
					Your roster has { gradeCount } grade { $wr.pluralize("level", gradeCount) }.
				</p>

				<RosterUploadButtons noun="Grades Levels"
					editMode={ this.state.editMode }
					forceEdits={ this.forceEdits() }
					nextStage={ this.tryNextStage }
					toggleEditMode={ this.toggleEditMode }
					confirmChanges={ this.confirmChanges } />

				<table className="table table-striped table-bordered csvConfirmTable" ref="table">
					<tbody>
						{ this.renderTableHeader() }
						{ this.renderTableRows() }
					</tbody>
				</table>

				{ archivedMapper }
			</div>
		)
	}
};

RosterUploadGrades.propTypes = StrictPropTypes({
	nextStage: PropTypes.func.isRequired,
	updateRosterData: PropTypes.func.isRequired,

	// Instance of StudentRoster.js
	roster: PropTypes.object.isRequired,

	// Students to consider porting over
	archivedStudents: PropTypes.array,


});

module.exports = RosterUploadGrades;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/RosterUploadGrades.js